import { useEffect, useState } from "react";

import { tModalName } from "../interfaces/interfaces";
import { useStoreSelector } from "../store/store";

interface iFirstPosition {
	position: 'first'
}
interface iLastPosition {
	position: 'last',
	modalName: tModalName
}


export const useTabIndex = (props: iFirstPosition | iLastPosition): boolean => {
	const [isTabinex, setIsTabIndex] = useState(false);
	const {openedModals} = useStoreSelector(store => store.modals);

	useEffect(() => {
		if (props.position === 'first'){
			setIsTabIndex(openedModals.length === 0);
		}
		if (props.position === 'last'){
			setIsTabIndex(openedModals[openedModals.length -1]?.modalName === props.modalName);
		}
		// eslint-disable-next-line
	}, [openedModals]);


	return isTabinex;
}